import { Controller } from 'stimulus';

class ToggleAccordion extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    const accordionTriggers = Array.prototype.slice.call(this.element.querySelectorAll('.collapse'));

    accordionTriggers.forEach((accordionTrigger) => {
      $(accordionTrigger).on('shown.bs.collapse hidden.bs.collapse', () => {
        const event = new CustomEvent('connector:recalculate', { bubbles: true });
        window.dispatchEvent(event);
      });
    });
  }
}

export default ToggleAccordion;
